import { Texture } from "pixi.js";
import { timer, take, interval, Observable } from "rxjs";

/**
 * Replica of setTimeout using rxjs
 * @param delay - Timeout time in milliseconds
 * @returns Observable
 */
export function rxSetTimeout(delay: number): Observable<number> {
    return timer(delay).pipe(take(1));
}

/**
 * Replica of setInterval using rxjs
 * @param delay - Interval time in milliseconds
 * @returns Observable
 */
export function rxSetInterval(intervalTime: number): Observable<number> {
    return interval(intervalTime);
}


async function fetchImageAsBlob(url: string): Promise<Blob> {
    const response = await fetch(url, { mode: 'cors' }); // Ensure CORS mode is enabled
    if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    const imageBlog = await response.blob()
    return imageBlog;
}

async function createTextureFromBlob(blob: Blob): Promise<Texture> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const texture = Texture.from(img);
            resolve(texture);
        };
        img.onerror = (event) => {
            reject(new Error('Failed to create texture from blob'));
        };
        img.src = URL.createObjectURL(blob);
    });
}

export async function loadAndUseImage(url: string): Promise<Texture> {
    try {
        const blob = await fetchImageAsBlob(url);
        const textureFromBlob = await createTextureFromBlob(blob)
        return textureFromBlob;
    } catch (error) {
        throw new Error('Error fetching the image')
    }
}
